function formatRelativeDate(value) {
    if (!value) {
        return null;
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return value;
    }

    const diffMs = Date.now() - date.getTime();
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffDays <= 0) {
        return 'сегодня';
    }
    if (diffDays === 1) {
        return 'вчера';
    }
    if (diffDays < 30) {
        return `${diffDays} дн. назад`;
    }

    const diffMonths = Math.floor(diffDays / 30);
    if (diffMonths < 12) {
        return `${diffMonths} мес. назад`;
    }

    const diffYears = Math.floor(diffMonths / 12);
    return `${diffYears} г. назад`;
}

export function mapUserInfo(data) {
    return {
        email: data?.email || '—',
        passwordUpdatedAt: data?.password_updated_at_label
            || formatRelativeDate(data?.password_updated_at)
            || '—',
    };
}
